export default __webpack_public_path__ + "img/8b35bf9f67a565398c194b3fdcfa5219.svg";